import { createSlice } from "@reduxjs/toolkit";

import { customDiagnosticType } from "@components/editor-page/editor-pane/utils/error-extractor";

export interface FormatCheckerState {
  formatIssues: customDiagnosticType[];
  count: number;
  editImageModalOpen: boolean;
}

const initialState: FormatCheckerState = {
  formatIssues: [],
  editImageModalOpen: false,
  count: 0,
};

export const formatCheckerSlice = createSlice({
  name: "formatChecker",
  initialState,
  reducers: {
    setFormatIssues: (state, action) => {
      state.formatIssues = action.payload;
      // check for issues tagged with warning severity
      const warningIssuesLength = action.payload.filter((issue: customDiagnosticType) => issue.severity === "warning").length;
      state.count = action.payload.length - warningIssuesLength;
    },
    setEditImageModal: (state, action) => {
      state.editImageModalOpen = action.payload;
    }
  }
});

export const { setFormatIssues, setEditImageModal } = formatCheckerSlice.actions;

export default formatCheckerSlice.reducer;